/** @jsxImportSource @emotion/react */

import { classNames, vars } from "@imwebme/clay-token";
import type { ElementType, Ref } from "react";
import { forwardRef } from "react";
import type { TypographyProps } from "./Typography.types";

/**
 * token은 두 가지 방법으로 넣어줄 수 있습니다. semanticToken, variant
 * 값은 body-medium이 default 입니다.
 */
const _Typography = <Element extends ElementType>(
  {
    as,
    semanticToken,
    variant = "body-medium",
    className = "",
    colorToken = "text",
    children,
    whiteSpace,
    numOfLine,
    sx,
    textAlign,
    native,
  }: TypographyProps<Element>,
  ref: Ref<HTMLElement>,
) => {
  const Element = as || "p";

  return (
    <Element
      className={`${classNames.typography[semanticToken || variant]} ${className}`}
      ref={ref as any}
      css={{
        color: vars.semantic.color[colorToken],
        ...(numOfLine && {
          display: "-webkit-box",
          overflow: "hidden",
          textOverflow: "ellipsis",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: numOfLine,
        }),
        whiteSpace,
        textAlign,
        ...sx,
      }}
      {...native}
    >
      {children}
    </Element>
  );
};

export const Typography = forwardRef(_Typography);

Typography.displayName = "Typography";
